export const INIT_PREMATCH_MENU = 'INIT_PREMATCH_MENU';
export const SUCCESS_INIT_PREMATCH_MENU = 'SUCCESS_INIT_PREMATCH_MENU';
export const FAILURE_INIT_PREMATCH_MENU = 'FAILURE_INIT_PREMATCH_MENU';



// WEBPACK FOOTER //
// ./js/actions/PreMatchMenu.js